import React from 'react';

import { Inject } from '@odinjs/odin';

import { HpmsCustomContentCollapseEvent, HPMSOnOpen } from '@philips-emr/hpms-components';
import HpmsCustomCardApi from '@philips-emr/hpms-components/lib/components/hpms-custom-card/hpms-custom-card-api';
import { Button, Stamp, StampIcon } from '@philips-emr/tws-components';
import { ButtonTheme, Color, Placement } from '@philips-emr/tws-constants';
import Controller, { OnAfterFetch, OnDynamicContentRender, OnMount, OnUnmount } from '@philips-emr/tws-core/lib/client';
import { Data } from '@philips-emr/tws-core/lib/component/context/data-context';
import { FetchEvent, MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import { HistoricoRequisicoesAliases as Aliases, FragmentNames } from '../../codegen';
import { Routes } from '../../definitions/routes';
import FilterService from '../../services/filter-service';
import BaseController from '../base/base-controller';

interface Requisicao {
  nrSequencia: number,
  nrSeqGuia: number,
  countGuias: number,
  dsEstagio: string,
  ieEstagio: number,
  nrSeqRequisicao: number,
}

@Controller({ fragment: FragmentNames.HISTORICO_REQUISICOES })
export default class HistoricoRequisicoesController extends BaseController {

  @Inject(Aliases.CUSTOM_CARD_REQUISICAO)
  private customCardRequisicao: HpmsCustomCardApi;

  @OnMount(Aliases.FILTER)
  onFilterMount = (event: MountEvent): void => FilterService.restoreFilterState(event);

  @OnUnmount(Aliases.FILTER)
  onFilterUnmount = (event: MountEvent): void => FilterService.persistFilterState(event);

  @OnAfterFetch(Aliases.CUSTOM_CARD_REQUISICAO)
  onAfterFetch({ data }: FetchEvent): void {
    if (!data) return;

    const { countGuias } = data as Requisicao;
    if (countGuias > 0) this.customCardRequisicao.setShowActionCollapse(true);
    this.customCardRequisicao.setShowActionCollapse(false);
  }

  @HPMSOnOpen(Aliases.HPMS_CUSTOM_CARD_CONTENT_COLLAPSE)
  onOpen(event: HpmsCustomContentCollapseEvent<Data>): void {
    if (!event || !event.data) {
      return;
    }

    const { nrSeqBeneficiario } = this.historyService.getCurrentRouteParams();
    const { nrSequencia } = event.data as unknown as Requisicao;

    const { onOpenRender } = event;
    onOpenRender({ parameters: { nrSeqBeneficiario, nrSeqRequisicao: nrSequencia } });
  }

  @OnDynamicContentRender(Aliases.HPMS_DYNAMIC_CONTENT_FIELD_ESTAGIO)
  onDynamicContentRenderEstagio({ data, render }: RenderEvent): void {
    const { dsEstagio, ieEstagio } = data as Requisicao;

    const props: { [key: number]: {} } = {
      1: { icon: StampIcon.CLOCK, color: Color.SAFETY_NEUTRAL },
      2: { icon: StampIcon.CHECK, color: Color.SAFETY_GREEN },
      3: { icon: StampIcon.CANCELED, color: Color.SAFETY_RED },
      4: { icon: StampIcon.WARNING, color: Color.SAFETY_YELLOW },
      7: { icon: StampIcon.CHECK, className: 'c-roxo-stamp__stamp--color' },
    };

    render(() => <Stamp {...props[ieEstagio]} label={`${dsEstagio}`} />);
  }

  @OnDynamicContentRender(Aliases.HPMS_DYNAMIC_CONTENT_FIELD_DETAILS)
  onDynamicContentRenderDetails(event: RenderEvent): void {
    const { data, render } = event;
    const { nrSequencia } = data as Requisicao;

    this.renderButton(render, nrSequencia);
  }

  @OnDynamicContentRender(Aliases.HPMS_DYNAMIC_CONTENT_FIELD_COLLPASE)
  onDynamicContentRenderCollapse(event: RenderEvent): void {
    const { data, render } = event;
    const { nrSeqRequisicao, nrSequencia } = data as unknown as Requisicao;

    this.renderButton(render, 0, () => this.getAutorizaçao(nrSeqRequisicao, nrSequencia));
  }

  private renderButton(render: Function, nrSeqRequisicao: number, onClick: Function = () => this.getRequisicao(nrSeqRequisicao)): void {
    render(() => (
      <Button
        key="report"
        icon="/static/assets/view-details.svg"
        theme={ButtonTheme.QUIET_EMPHASIS}
        value=""
        iconPlacement={Placement.LEFT}
        onClick={() => onClick()}
        className="c-historico-requisicao-consulta__custom-action-button"
      />
    ));
  }

  private getRequisicao(nrSeqRequisicao: number): void {
    this.historyService.push(Routes.DETALHES_REQUISICAO, { nrSeqRequisicao });
  }

  private getAutorizaçao(nrSeqRequisicao: number, nrSeqGuia: number): void {
    this.historyService.push(Routes.DETALHES_REQUISICAO_AUTORIZACAO, { nrSeqRequisicao, nrSeqGuia });
  }
}
